<template>
    
    <div class="verificator">

        <div class="w-100 bg-black rounded text-white vertical-center">
            <div class="row">
                <div class="col-md-4 border-0 border-end border-info">
                    <div class="p-1">
                        <img :src="require(`@/assets/app/vry.jpg`)" alt="Kraken - Verificator" width="300" height="300" class="rounded">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="bg-black p-4" :class="{'temporal-disable': verifying}">
                        <div class="fw-bold fs-1 gradient-text" style="letter-spacing: 7px;">Kraken</div>
                        <div class="fw-light fs-4 w-100 text-info" style="letter-spacing: 3px;">Verificator</div>
                        <div class="mt-3"></div>
                        <form class="" action="">
                            <input class="btn bg-input w-100" style="cursor: text;" type="text" placeholder="Username" v-model="form.username">
                            <input class="btn bg-input w-100 mt-2" style="cursor: text;" type="password" placeholder="Password" v-model="form.password">
                            <input class="btn bg-input w-100 mt-2" style="cursor: text;" type="password" placeholder="Confirmation" v-model="form.confirmation">
                        </form>
                        <button v-if="(form.password == form.confirmation) & !([null, ''].includes(form.password))" class="btn btn-kraken w-100 mt-2" @click="verify" title="Verify identity.">
                            <i class="fa-solid" :class="{'fa-fingerprint': !verifying, 'fa-refresh fa-spin': verifying}"></i>
                        </button>
                    </div>
                </div>            
                <div class="col-md-4 border-0 border-start border-info">
                    <div v-if="policy != null" class="bg-black p-4">
                        <div class="fw-light fs-4 w-100 text-info" style="letter-spacing: 3px;">Password policy</div>
                        <div class="input-group flex-nowrap mt-3">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                <i class="fa-solid fa-arrows-left-right-to-line"></i>
                            </button>
                            <div class="btn bg-input w-100 text-info fs-6" style="pointer-events: none;">
                                Minimum length: {{policy.length}}
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-1">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                ABC
                            </button>
                            <div class="btn bg-input w-100 text-info fs-6" style="pointer-events: none;">
                                Minimum uppercase characters: {{policy.uppercase_min}}
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-1">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                abc
                            </button>
                            <div class="btn bg-input w-100 text-info" style="pointer-events: none;">
                                Minimum lowercase characters: {{policy.lowercase_min}}
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-1">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                123
                            </button>
                            <div class="btn bg-input w-100 text-info" style="pointer-events: none;">
                                Minimum quantity of numbers: {{policy.numbers}}
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-1">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                <i class="fa-solid fa-star"></i>
                            </button>
                            <div class="btn bg-input w-100 text-info" style="pointer-events: none;">
                                Minimum special characters: {{policy.special}}
                            </div>
                        </div>
                        <div class="input-group flex-nowrap mt-1">
                            <button class="btn btn-kraken" style="pointer-events: none; width: 17%;">
                                <i class="fa-solid fa-hashtag"></i>
                            </button>
                            <div class="btn bg-input w-100 text-info" style="pointer-events: none;">
                                Allowed special characters: {{policy.specials}}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import axios from "axios";

export default {
  name: 'Login',
  data() {
      return {
        //appServiceUrl: process.env.VUE_APP_SERVICE_URL,
        site: null,
        stage: null,
        form:{
            username: null,
            password: null,
            confirmation: null,
            token_url: null
        },
        verifying: false,
        policy: {
            "length": 15,
            "lowercase_min": 1,
            "name": "basic",
            "numbers": 1,
            "special": 1,
            "specials": "$%",
            "uid": 9,
            "uppercase_min": 1
        }
      }
  },
  methods: {
    verify(){
        this.verifying = true
        // Verification
        if (!this.form.username || !this.form.password || !this.form.confirmation){
            alert('Verify the data')
            return
        }
        if (!this.form.token_url){
            alert('Invalid site.')
            return
        }
        const dest = this.site + '/suite/main/identity'
        axios
            .post(dest, { 
                username: this.form.username, 
                password: this.form.password, 
                confirmation: this.form.confirmation, 
                token_url: this.form.token_url
            })
            .then(rx => {
                this.verifying = false
                console.log(rx.data)
                if (rx.data.message == 'OK'){
                    alert('Verification completed.')
                }
            })
            .catch(error => {
                try {
                    alert(`${error.response.data.error}.`)
                } catch (error) {
                    alert(`${error.response.data.data.error}.`)
                }
                this.verifying = false
            });
    },
    getPolicy(){
        this.policy = null
        this.getting_policy = true
        const dest = this.site + '/suite/main/policy'
        const params = { token_url: this.$route.params.temp }
        axios
            .get(dest, {params})
            .then(rx => {
                this.getting_policy = false
                this.policy = rx.data[0]
            })
            .catch(error => {
                this.getting_policy = false
            });
    },
    setCookie(name, value){
        Cookies.set(name, value);
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  mounted: function(){
    if (process.env.NODE_ENV == 'development'){
        this.site = process.env.VUE_APP_SERVICE_URL
    }
    this.getPolicy()
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    this.form.token_url = this.$route.params.temp
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
  } 
}
</script>

<style scoped>

    .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

    .btn-kraken{
        background-color: rgb(0, 52, 120);
        color: white;
    }

    .verificator{
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        overflow: hidden;
        overflow-y: hidden;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    
    .temporal-disable{
        pointer-events: none;
        opacity: 0.3;
    }

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 158, 249);
    }
    
    .gradient-text{
        background-image: linear-gradient(rgb(57, 198, 249), rgb(0, 34, 90));
        color: transparent;
        background-clip: text;
    }
    .gradient-text:hover{
        background-image: linear-gradient(rgb(0, 34, 90), rgb(57,198,249));
        color: transparent;
        background-clip: text;
    }

</style>